import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import * as momentTimezone from 'moment-timezone';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import { SiteService, SiteStepperService } from 'src/app/services/index';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, Constants, DateService } from 'src/app/shared/index';
import * as ObjectUtils from 'util';

export interface ShiftDetail {
  shiftId: string;
  shiftStart: any;
  shiftEnd: any;
  shiftName: string;
}

@Component({
  selector: 'app-shift-details',
  templateUrl: './shift-details.component.html',
  styleUrls: ['./shift-details.component.scss']
})
export class ShiftDetailsComponent implements OnInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  formdata: FormGroup;
  displayedColumns = [
    'shiftId',
    'shiftName',
    'shiftStart',
    'shiftEnd',
    'actions'
  ];
  siteId: string;
  maxNoOfShift = 4;
  shifts = [];
  formControlIndex = [];
  indexCount = 0;

  moment = extendMoment(Moment);
  dataSource: MatTableDataSource<ShiftDetail>;
  isOverlapShiftTime = true;
  isDuplicatedShiftId = true;
  isDuplicatedShiftName = true;
  isShiftStartTimePresent = false;
  isShiftEndTimePresent = false;
  time: any;
  siteModel: SiteModel;
  siteTimezone: string;
  public timeValue1: FormControl = new FormControl();
  public timeValue2: FormControl = new FormControl();
  constructor(
    private alertService: AlertService,
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private siteService: SiteService,
    private dateService: DateService,
    private siteStepperService: SiteStepperService
  ) {}

  ngOnInit() {
    this.formdata = this.fb.group({
      index: [
        '',
        [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(250)
        ]
      ]
    });

    this.initFirstShift();
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ShiftDetails &&
        !ObjectUtils.isNullOrUndefined(data.siteModel)
      ) {
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        this.siteTimezone = data.siteModel.timezone;
        this.loadShifts(this.siteId);
      }
    });
  }

  loadShifts(siteId) {
    this.siteService.getShiftsBySiteId(siteId).subscribe((data) => {
      if (data.length > 0) {
        this.formControlIndex = [];
        this.shifts = [];

        this.time = new Date(data[0].shiftStart);
        for (let i = 0; i < data.length; i++) {
          const shift: ShiftDetail = {
            shiftId: ObjectUtils.isNullOrUndefined(data[i].shiftId)
              ? ''
              : data[i].shiftId,
            shiftStart: Moment(data[i].shiftStart)
              .utc()
              .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT),
            shiftEnd: Moment(data[i].shiftEnd)
              .utc()
              .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT),
            shiftName: data[i].shiftName
          };
          this.shifts.push(shift);
          this.initFormControls(i);
        }
        this.indexCount = this.shifts.length;
        this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);
        this.validateInput();
        this.isFormValid();
      }
      this.isOverlapShiftTime = false;
      this.isDuplicatedShiftId = false;
      this.isDuplicatedShiftName = false;
    });
  }

  formatTwoNumber(n) {
    return n > 9 ? '' + n : '0' + n;
  }

  initFirstShift() {
    this.initFormControls(0);

    this.shifts = [this.initShift()];
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);
    this.isOverlapShiftTime = false;
    this.isDuplicatedShiftId = false;
    this.isDuplicatedShiftName = false;
  }

  initShift() {
    return {
      shiftId: '',
      shiftName: '',
      shiftStart: '',
      shiftEnd: ''
    };
  }

  clear(index) {
    this.shifts[index] = this.initShift();
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);

    this.validateInput();
  }

  remove(index) {
    // Clear controls
    const formIndex = this.formControlIndex[index];
    const shiftNameControl = 'shiftName' + formIndex;
    this.formdata.removeControl(shiftNameControl);
    const shiftIdControl = 'shiftId' + formIndex;
    this.formdata.removeControl(shiftIdControl);

    this.shifts.splice(index, 1);
    this.formControlIndex.splice(index, 1);
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);

    const shiftStartControl = 'shiftStart' + formIndex;
    this.formdata.removeControl(shiftStartControl);
    const shiftEndControl = 'shiftEnd' + formIndex;
    this.formdata.removeControl(shiftEndControl);

    let formdataVal = this.formdata.value;
    // console.log("formdataVal: ",formdataVal["shiftEnd3"])
    // let i = formIndex;
    for (let i = formIndex; i != -1; i--) {
      console.log('i: ', i);
      let shiftEndi = 'shiftEnd' + i;
      // console.log("shiftEndi: ",shiftEndi,JSON.stringify(formdataVal["shiftEnd"+i]))

      if (formdataVal['shiftEnd' + i] != undefined) {
        if (formdataVal['shiftEnd' + i] != '') {
          // this.isShiftEndTimePresent = false;
          // console.log("1st if this.formdata.value."+shiftEndi+ ": "+formdataVal["shiftEnd"+i])
        } else {
          // console.log("2nd if this.formdata.value."+shiftEndi+ ": "+formdataVal["shiftEnd"+i])
          this.isShiftEndTimePresent = true;
        }
      } else {
        // console.log("else if this.formdata.value."+shiftEndi+ ": "+formdataVal["shiftEnd"+i])
        // console.log("inside else: ")
      }

      if (formdataVal['shiftStart' + i] != undefined) {
        if (formdataVal['shiftStart' + i] != '') {
          // this.isShiftEndTimePresent = false;
          // console.log("1st if this.formdata.value."+shiftEndi+ ": "+formdataVal["shiftStart"+i])
        } else {
          // console.log("2nd if this.formdata.value."+shiftEndi+ ": "+formdataVal["shiftStart"+i])
          this.isShiftStartTimePresent = true;
        }
      } else {
        // console.log("else if this.formdata.value."+shiftEndi+ ": "+formdataVal["shiftStart"+i])
        // console.log("inside else: ")
      }
    }

    this.validateInput();
  }

  add() {
    this.indexCount = this.indexCount + 1;
    this.shifts.push(this.initShift());
    this.initFormControls(this.indexCount);
    this.dataSource = new MatTableDataSource<ShiftDetail>(this.shifts);

    this.validateInput();
  }

  validateTimeSlotsShiftStart(event, index) {
    let val: any;
    if (event.target === null || event.target === undefined) {
      val = this.shifts[index].shiftStart;
    } else {
      val = event.target.value;
    }
    const splitHour = val.split(':');
    const found = this.shifts[index];
    if (found) {
      const tempDate = new Date(new Date().getFullYear());
      const tempDateEnd = new Date(new Date().getFullYear());
      // Set hours
      if (splitHour != '') {
        this.isShiftStartTimePresent = false;

        if (splitHour[0] != null) {
          tempDate.setHours(splitHour[0]);
        }
        // Then set minutes
        if (splitHour[1] != null) {
          tempDate.setMinutes(splitHour[1]);
        }
        // Then set seconds
        if (splitHour[2] != null) {
          tempDate.setSeconds(splitHour[2]);
        }
      } else {
        // found.shiftStart = "";
        this.isShiftStartTimePresent = true;
        // console.log("found in else : ",found)
      }
    }
    this.isOverlapShiftTime = this.isOverlapTime();
  }

  validateTimeSlotsShiftEnd(event, index) {
    let val: any;
    if (event.target === null || event.target === undefined) {
      val = this.shifts[index].shiftEnd;
    } else {
      val = event.target.value;
    }
    const splitHour = val.split(':');
    const found = this.shifts[index];
    if (found) {
      const tempDate = new Date(new Date().getFullYear());
      const tempDateStart = new Date(new Date().getFullYear());
      // Set hours
      if (splitHour != '') {
        this.isShiftEndTimePresent = false;

        if (splitHour[0] != null) {
          tempDate.setHours(splitHour[0]);
        }
        // Then set minutes
        if (splitHour[1] != null) {
          tempDate.setMinutes(splitHour[1]);
        }
        // Then set seconds
        if (splitHour[2] != null) {
          tempDate.setSeconds(splitHour[2]);
        }
      } else {
        // found.shiftStart = "";
        this.isShiftEndTimePresent = true;
        // console.log("found in else : ",found)
      }
    }

    this.isOverlapShiftTime = this.isOverlapTime();
  }

  isOverlapTime() {
    const result = false;
    const timeRanges = Object.assign([], this.shifts);

    if (timeRanges.length < 2) {
      return false;
    }

    for (let i = 0; i < timeRanges.length - 1; i++) {
      for (let j = i + 1; j < timeRanges.length; j++) {
        let isAdded1 = false;
        let isAdded2 = false;
        let start1 = new Date(timeRanges[i].shiftStart);
        let end1 = new Date(timeRanges[i].shiftEnd);
        if (start1 > end1) {
          end1 = this.addDay(timeRanges[i].shiftEnd, 1);
          isAdded1 = true;
        }
        let start2 = new Date(timeRanges[j].shiftStart);
        let end2 = new Date(timeRanges[j].shiftEnd);
        if (start2 > end2) {
          end2 = this.addDay(timeRanges[j].shiftEnd, 1);
          isAdded2 = true;
        }

        if (isAdded1 && !isAdded2) {
          start2 = this.addDay(timeRanges[j].shiftStart, 1);
          end2 = this.addDay(timeRanges[j].shiftEnd, 1);
        }
        if (!isAdded1 && isAdded2) {
          start1 = this.addDay(timeRanges[i].shiftStart, 1);
          end1 = this.addDay(timeRanges[i].shiftEnd, 1);
        }

        const range1 = this.moment.range(start1, end1);
        const range2 = this.moment.range(start2, end2);
        if (range1.overlaps(range2, { adjacent: true })) {
          return true;
        }
      }
    }

    return result;
  }

  addDay(dateString, addToDays) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + addToDays);
    return date;
  }

  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ConnectionDetails, this.siteModel)
    );
  };

  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.ProcessAndLoadDetails,
        this.siteModel
      )
    );
  };

  submitShifts() {
    const t = this;
    const shiftData = cloneDeep(this.shifts);
    shiftData.forEach((shift) => {
      const splitHourStartTime = shift.shiftStart.split(':');
      const splitHourEndTime = shift.shiftEnd.split(':');
      shift.shiftStart = momentTimezone
        .tz(
          {
            hour: splitHourStartTime[0],
            minute: splitHourStartTime[1],
            second: 0,
            millisecond: 0
          },
          this.siteTimezone
        )
        .format();

      shift.shiftEnd = momentTimezone
        .tz(
          {
            hour: splitHourEndTime[0],
            minute: splitHourEndTime[1],
            second: 0,
            millisecond: 0
          },
          this.siteTimezone
        )
        .format();
    });

    t.siteService.saveShifts(shiftData, t.siteId).subscribe((response) => {
      if (!ObjectUtils.isNullOrUndefined(response)) {
        this.alertService.message = 'Saved Successfully';
        this.alertService.showSuccess();
      } else {
        this.alertService.message = 'Failure in saving the data!';
        this.alertService.showError();
      }
    });
  }

  private initFormControls(index: number) {
    this.formControlIndex.push(index);

    const shiftNameControl = 'shiftName' + index;

    if (ObjectUtils.isNullOrUndefined(this.formdata.get(shiftNameControl))) {
      this.formdata.addControl(
        shiftNameControl,
        new FormControl('', Validators.required)
      );
    }

    const shiftIdControl = 'shiftId' + index;
    if (ObjectUtils.isNullOrUndefined(this.formdata.get(shiftIdControl))) {
      this.formdata.addControl(
        shiftIdControl,
        new FormControl('', Validators.required)
      );
    }

    const shiftStartControl = 'shiftStart' + index;
    if (ObjectUtils.isNullOrUndefined(this.formdata.get(shiftStartControl))) {
      this.formdata.addControl(
        shiftStartControl,
        new FormControl(new Date(), Validators.required)
      );
    }

    const shiftEndControl = 'shiftEnd' + index;
    if (ObjectUtils.isNullOrUndefined(this.formdata.get(shiftEndControl))) {
      this.formdata.addControl(
        shiftEndControl,
        new FormControl(new Date(), Validators.required)
      );
    }
  }

  validateShiftId() {
    this.isDuplicatedShiftId = this.isDuplicateShiftId();
  }

  isDuplicateShiftId() {
    let isDuplicated = false;
    if (this.shifts.length > 1) {
      for (let i = 0; i < this.shifts.length - 1; i++) {
        for (let j = i + 1; j < this.shifts.length; j++) {
          if (
            this.shifts[i].shiftId.toString() ===
            this.shifts[j].shiftId.toString()
          ) {
            isDuplicated = true;
            break;
          }
        }
        if (isDuplicated) {
          break;
        }
      }
    }
    return isDuplicated;
  }

  validateShiftName() {
    this.isDuplicatedShiftName = this.isDuplicateShiftName();
  }

  isDuplicateShiftName() {
    let isDuplicated = false;
    if (this.shifts.length > 1) {
      for (let i = 0; i < this.shifts.length - 1; i++) {
        for (let j = i + 1; j < this.shifts.length; j++) {
          if (
            this.shifts[i].shiftName.toString() ===
            this.shifts[j].shiftName.toString()
          ) {
            isDuplicated = true;
            break;
          }
        }
        if (isDuplicated) {
          break;
        }
      }
    }
    return isDuplicated;
  }

  private validateInput() {
    this.isDuplicatedShiftId = this.isDuplicateShiftId();
    this.isDuplicatedShiftName = this.isDuplicateShiftName();
    this.isOverlapShiftTime = this.isOverlapTime();
  }

  isFormValid() {
    if (this.isDuplicatedShiftId) {
      return false;
    }

    if (this.isDuplicatedShiftName) {
      return false;
    }

    if (this.isOverlapShiftTime) {
      return false;
    }

    if (this.isShiftStartTimePresent) {
      return false;
    }

    if (this.isShiftEndTimePresent) {
      return false;
    }

    let isEmptyShiftName = false;
    let isEmptyShiftId = false;
    for (let i = 0; i < this.shifts.length; i++) {
      // Check Shift Id
      if (
        ObjectUtils.isNullOrUndefined(this.shifts[i].shiftId) ||
        this.shifts[i].shiftId === ''
      ) {
        isEmptyShiftId = true;
        break;
      }
      // Check Shift Name
      if (
        ObjectUtils.isNullOrUndefined(this.shifts[i].shiftName) ||
        this.shifts[i].shiftName === ''
      ) {
        isEmptyShiftName = true;
        break;
      }
    }
    if (isEmptyShiftName || isEmptyShiftId) {
      return false;
    }

    return true;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
